<template>
  <div>
    <div class="text-center m-b">
      <button
        v-for="tipo in tiposFormula"
        :key="tipo"
        type="button"
        class="btn m-r-xs"
        :class="`${modelo.tipo == tipo ? 'btn-cifra' : 'btn-default'}`"
        @click="cambiarTipoFormula(tipo)"
      >
        {{ $I18n.t(`enum_formula_tipo.${tipo}`) }}
      </button>
    </div>
    <component
      :is="vistasTipoFormula[modelo.tipo]"
      ref="editor"
      v-model="modelo"
      :variables-disponibles="variables"
      @eliminar-variable-disponible="eliminarVariableDisponible($event)"
    >
    </component>
    <div class="subtitulo-seccion">
      {{ $t('Configuracion') }}
    </div>
    <div class="row m-b-lg">
      <div class="col-xs-6">
        <label for="" class="control-label">
          {{ $t('tratamiento_blancos') }}
        </label>
        <select
          v-model="modelo.tipo_blancos"
          class="form-control"
        >
          <option
            v-for="tipo in tipoBlancos"
            :key="tipo.value"
            :value="tipo.value"
          >
            {{ tipo.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row m-b-lg">
      <div class="col-xs-6">
        <InputCheckboxBoolean v-model="redondeoActivo" tipo="switch">
          {{ $t('Redondeo_notas') }}
        </InputCheckboxBoolean>
      </div>
      <div
        ref="redondeoWrapper"
        class="col-xs-6 redondeo-wrapper"
        :class="redondeoWrapperClass"
      >
        <div class="wrapper-slider">
          <div class="redondeo slider"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { markRaw } from 'vue';
import { cloneDeep } from 'lodash';
import EditorSuma from './EditorSuma.vue';
import EditorMedia from './EditorMedia.vue';
import EditorPonderada from './EditorPonderada.vue';
import EditorSimple from './EditorSimple.vue';

export default {
  props: {
    // Lista de objetos VariableFormula
    variablesDisponibles: { type: Array, required: true },
    modelValue: { type: Object, default: () => ({}) },
  },
  emits: ['update:modelValue', 'update:variablesDisponibles'],
  data() {
    const variables = [...this.variablesDisponibles];
    const vistasTipoFormula = {
      suma: EditorSuma,
      media: EditorMedia,
      ponderada: EditorPonderada,
      manual: EditorSimple,
    };
    const modelo = cloneDeep(this.modelValue);
    modelo.tipo = modelo.tipo || 'media';
    return {
      redondeoInicial: parseFloat(modelo.redondeo || 0.5),
      redondeoActivo: modelo.redondeo > 0,
      tiposFormula: Object.keys(vistasTipoFormula),
      modelo,
      variables,
      // No es reactivo
      vistasTipoFormula: markRaw(vistasTipoFormula),
      tipoBlancos: [
        { name: this.$t('activerecord.enums.calificaciones/formula.tipo_blancos.no_calcular'), value: 'no_calcular' },
        { name: this.$t('activerecord.enums.calificaciones/formula.tipo_blancos.como_ceros'), value: 'como_ceros' },
        { name: this.$t('activerecord.enums.calificaciones/formula.tipo_blancos.excluir'), value: 'excluir' },
      ],
    };
  },
  computed: {
    redondeoWrapperClass() {
      return !this.redondeoActivo ? 'hidden' : '';
    },
  },
  watch: {
    variablesDisponibles() {
      this.variables = [...this.variablesDisponibles];
    },
    modelValue() {
      this.modelo = cloneDeep(this.modelValue);
    },
    redondeoActivo(activo) {
      if (!activo) {
        this.setRedondeoValue(null);
      } else {
        this.setRedondeoValue(this.modelo.redondeo || this.redondeoInicial);
      }
    },
  },
  mounted() {
    if (this.redondeoActivo) {
      this.setRedondeoValue(this.modelo.redondeo);
    }

    this.initSlider();
  },
  methods: {
    initSlider() {
      /* global $ */
      const _self = this;
      $(this.$refs.redondeoWrapper).find('.slider').each(function cargarSlider() {
        const $slider = $(this);

        $slider.slider({
          min: 0,
          max: 1,
          step: 0.05,
          value: _self.redondeoInicial,
          create(event, _ui) {
            $(event.target).find('.ui-slider-handle').append(`<span class="ui-slider-tooltip">${_self.redondeoInicial.toString().replace('.', ',')}%</span>`);
          },
          slide(_event, ui) {
            $slider.find('.ui-slider-tooltip').text(String(ui.value).replace('.', ','));
            _self.setRedondeoValue(ui.value);
          },
        });
      });
    },
    setRedondeoValue(value) {
      this.modelo.redondeo = value;
    },
    getFormulaData() {
      return this.modelo;
    },
    validar() {
      const data = this.getFormulaData();
      if (data.tipo === 'manual' && data.tipo_blancos === 'excluir') {
        throw new Error(this.$t('tipo_blancos_excluir_no_valido_para_manual'));
      }
    },
    cambiarTipoFormula(tipo) {
      // Si pasan a manual no hace falta limpiar, todas son válidas
      if (tipo === 'manual') {
        this.modelo.formula = this.modelValue.formula;
      } else {
        this.modelo.formula = '';
      }
      this.modelo.tipo = tipo;
      this.$emit('update:modelValue', this.modelo);
    },
    eliminarVariableDisponible(variable) {
      const filtro = (v) => v.nombre_variable !== variable.nombre_variable;
      this.modelo.formula_variables = this.modelo.formula_variables.filter(filtro);
      this.$emit('update:modelValue', this.modelo);
      this.variables = this.variables.filter(filtro);
      this.$emit('update:variablesDisponibles', this.variables);
    },
  },
};
</script>

<style lang="scss" scoped>
// Si el formulario principal está con form-horizontal bootstrap nos mete márgenes
.form-group {
  margin-left: 0;
  margin-right: 0;
}
.wrapper-slider {
  height: 40px
}
.redondeo-wrapper {
  margin-top: -10px;
}
</style>
